const practiceScore = [{
  path: 'practiceScore/index',
  component: resolve => require(['../../../../components/pages/studentresults/practiceScore'], resolve)
}]
export default practiceScore
